module.exports = __webpack_public_path__ + "img/App Display.3bda0e6d.png";